'use client'

import React, {useEffect, useState} from 'react'
import {useParams} from 'next/navigation'

const DeviceCheck = ({children}: {children: React.ReactNode}) => {
  const params = useParams()
  const [windowWidth, setWindowWidth] = useState<number>(0)
  const bjId = params.bjId as string
  const broadNo = (params.broadNo as string) || '0'

  useEffect(() => {
    // const userAgent = navigator.userAgent || ''
    // const isMobile = /Android|iPhone|iPad|Mobile/i.test(userAgent)
    // const isGooglePageSpeed = /Googlebot|Lighthouse/i.test(userAgent)

    // console.log('User-Agent:', userAgent, 'Is Mobile:', isMobile)
    // console.log('Is Google PageSpeed:', isGooglePageSpeed)

    setWindowWidth(window.innerWidth)
    if (broadNo != 'direct') {
      if (window.innerWidth < 1024) {
        const url = `https://m.onlive.vn/#/player/${bjId}/${broadNo}`
        window.location.href = url
      }
    }
  }, [])

  if (windowWidth < 1024) return <></>

  return <>{children}</>
}

export default DeviceCheck
